import { AppBar, Box, Container, Toolbar } from '@mui/material';

import LanguagePickerButton from 'components/@common/LanguagePickerButton';
import HideOnScroll from 'components/@navigation/HideOnScroll';

import Breadcrumbs from './Breadcrumbs';
import { Breadcrumb } from './types';

interface Props {
  items?: Array<Breadcrumb>;
  hideOnDesktop?: boolean;
  hideOnMobile?: boolean;
}

const PageBreadcrumbs = ({ items, hideOnMobile, hideOnDesktop }: Props) => {
  return (
    <>
      {/* Mobile */}
      <Box
        sx={{
          display: { xs: hideOnMobile ? 'none' : 'block', md: 'none' },
        }}
      >
        <HideOnScroll>
          <AppBar color="default">
            <Toolbar sx={{ justifyContent: 'space-between', p: 2, gap: 1 }}>
              <Breadcrumbs items={items} />
              <LanguagePickerButton />
            </Toolbar>
          </AppBar>
        </HideOnScroll>
        <Toolbar sx={{ minHeight: 72 }} />
      </Box>
      {/* Desktop */}
      <Box
        sx={{
          bgcolor: 'background.default',
          zIndex: 1,
          display: { xs: 'none', md: hideOnDesktop ? 'none' : 'block' },
        }}
      >
        <Container component="section">
          <Breadcrumbs items={items} />
        </Container>
      </Box>
    </>
  );
};

export default PageBreadcrumbs;
